<template>
  <Modal
    :value="value"
    class-name="vc-user-managed-hub-modal"
    width="640"
    :footer-hide="true"
    :mask-closable="true"
    @on-visible-change="onVisibleChange"
    @input="$emit('input', $event)"
  >
    <div class="vc-user-managed-hub">
      <div class="vc-user-managed-hub__head">
        <div class="vc-user-managed-hub__title">{{ title }}</div>
        <Tabs
          v-model="activeTabSync"
          name="vcUserManagedHub"
          class="vc-user-managed-hub__tabs vc-user-managed-hub__tabs--bar-only"
        >
          <TabPane :label="addTabLabel" name="add" tab="vcUserManagedHub" />
          <TabPane :label="manageTabLabel" name="manage" tab="vcUserManagedHub" />
        </Tabs>
      </div>
      <div class="vc-user-managed-hub__body">
        <div v-show="activeTabSync === 'add'" class="vc-user-managed-hub__pane">
          <slot name="add" />
        </div>
        <div v-show="activeTabSync === 'manage'" class="vc-user-managed-hub__pane">
          <div v-if="usageText" class="vc-user-managed-hub__usage">{{ usageText }}</div>
          <slot name="manage" :switch-tab="switchTab" />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'UserManagedHubModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    addTabLabel: {
      type: String,
      default: '添加资源',
    },
    manageTabLabel: {
      type: String,
      default: '管理资源',
    },
    activeTab: {
      type: String,
      default: 'add',
    },
    usageText: {
      type: String,
      default: '',
    },
  },
  computed: {
    activeTabSync: {
      get() {
        return this.activeTab === 'manage' ? 'manage' : 'add'
      },
      set(v) {
        this.$emit('update:activeTab', v === 'manage' ? 'manage' : 'add')
      },
    },
  },
  methods: {
    onVisibleChange(visible) {
      this.$emit('visible-change', visible)
    },
    switchTab(name) {
      const tab = name === 'manage' ? 'manage' : 'add'
      this.$emit('update:activeTab', tab)
    },
  },
}
</script>

<style lang="scss">
.vc-user-managed-hub-modal {
  .ivu-modal-header {
    display: none;
  }

  .ivu-modal-body {
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
.vc-user-managed-hub {
  &__head {
    padding: 24px 24px 0;
    background: linear-gradient(180deg, #eef5ff 0%, #fff 100%);
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
    margin-bottom: 16px;
    text-align: left;
  }

  &__tabs--bar-only {
    ::v-deep .ivu-tabs-bar {
      margin-bottom: 0;
      border-bottom: 1px solid #e8eaec;
    }

    ::v-deep .ivu-tabs-content {
      display: none !important;
      height: 0 !important;
      overflow: hidden;
    }
  }

  &__body {
    padding: 16px 24px 24px;
    background: #fff;
    min-height: 120px;
  }

  &__pane {
    min-height: 80px;
  }

  &__usage {
    font-size: 13px;
    color: #909399;
    margin-bottom: 12px;
    text-align: left;
  }
}
</style>
